import { useContext, useEffect, useState } from "react"
import { AppText, CustomContainer } from "src/style"
import { AppTable } from "src/component"
import ApiContext from 'src/provider/API/call-service';
import { transactionColumns, transactionData } from "src/utils/tableLayout"
import { TransactionDetails } from "src/popup"

export const Transactions: React.FC<any> = ({}) => {
    const {API} = useContext(ApiContext)
    const [transactions, setTransactions] = useState<any>(null)
    const [isTransactionDetails, setIsTransactionDetails] = useState(false)
    const [selectedTransaction, setSelectedTransaction] = useState<any>(null)

    function handleSelectedTransaction (rowData: any) {
        setSelectedTransaction(rowData)
        setIsTransactionDetails(true)
    }

    useEffect(() => {
        fetchCustomerTransaction()
    }, [])

    async function fetchCustomerTransaction (startDate = '', endDate = '') {
        const response = await API.getTransactionHistoryByDate({startDate, endDate})
        if (response) setTransactions(response)
    }

    return (
        <>
            <CustomContainer>
                <AppText textSize="1.8" fontWeight="700" color="#27272E" topMargin="3">Transactions</AppText>
                <CustomContainer topMargin="2.5">
                    <AppTable
                        columns={transactionColumns} 
                        data={transactions}
                        onRowClick={handleSelectedTransaction}
                        hasStripe
                        rowHeight='7.9'
                        canFilter
                        canSearch
                        canDateSearch
                        flexSwitch
                    />
                </CustomContainer>
            </CustomContainer>
            { isTransactionDetails &&
                <TransactionDetails 
                    close={() => setIsTransactionDetails(false)}
                    data={selectedTransaction}
                />
            }
        </>
    )
}